import React, { ChangeEventHandler, FunctionComponent, useState } from 'react'
import {
  Box,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel
} from '@material-ui/core'
import { FileCopy, Visibility, VisibilityOff } from '@material-ui/icons'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useSnackbar } from 'notistack'
import { useIntl } from 'react-intl'

interface Props {
  canCopy?: boolean,
  canReveal?: boolean,
  label?: string,
  onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>,
  value: string
}

const PasswordInput: FunctionComponent<Props> = (props: Props) => {
  const {
    canCopy,
    canReveal,
    label,
    onChange,
    value
  } = props
  const intl = useIntl()
  const { enqueueSnackbar } = useSnackbar()
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const onCopy = () => {
    enqueueSnackbar(intl.formatMessage({
      id: 'passwordInput.passwordCopied',
      description: 'Password copied to clipboard notification text',
      defaultMessage: 'Password copied to clipboard!'
    }))
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault()
  }

  return (
    <Box mx={2} my={1}>
      <FormControl style={{ width: '100%' }}>
        { label &&
          <InputLabel htmlFor="standard-adornment-password">{label}</InputLabel>
        }
        <Input
          id="standard-adornment-password"
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          inputProps={{ spellCheck: false }}
          endAdornment={
            <InputAdornment position="end">
              { canReveal &&
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              }
              { canCopy &&
                <CopyToClipboard text={value} onCopy={onCopy}>
                  <IconButton
                    aria-label="copy password to clipboard"
                    onMouseDown={handleMouseDownPassword}
                  >
                    <FileCopy />
                  </IconButton>
                </CopyToClipboard>
              }
            </InputAdornment>
          }
        />
      </FormControl>
    </Box>
  )
}

export default PasswordInput
